/**
 * Browser entry point. Routes between the app and the diagnostics doctor by hash, mounts into `#app`,
 * and registers the service worker. Everything below this line is DOM-bound; the protocol/state
 * machinery lives in the DOM-free `core/`.
 */
import { App } from './app/app.ts';
import { DiagnosticsPage } from './app/diagnosticsPage.ts';
import { parseJoinLink } from './core/session/index.ts';

const mount = document.getElementById('app');
if (!mount) {
  throw new Error('missing #app mount element');
}

const language = globalThis.navigator?.language ?? 'en';

// A minimal hash router: `#/diagnostics` is its own entry (no auth for the connectivity half,
// web-client.md §8); everything else is the app. Switching hashes reloads for a clean remount.
let currentRoute = route();
function route(): 'diagnostics' | 'app' {
  return globalThis.location.hash.replace(/^#/, '') === '/diagnostics' ? 'diagnostics' : 'app';
}

// A join link changes the hash, and the app consumes it by REPLACING the URL. Reloading on that
// would restart the client mid-join, so the hash listener below ignores anything that is not a
// change of route.

if (currentRoute === 'diagnostics') {
  new DiagnosticsPage(mount, language).start();
} else {
  // An invitation link is still "the app" - it just arrives knowing which session to open. Parsing it
  // here keeps App free of the router.
  const app = new App(mount, language, parseJoinLink(globalThis.location.hash) ?? undefined);
  app.start();
}

globalThis.addEventListener('hashchange', () => {
  if (route() !== currentRoute) {
    currentRoute = route();
    globalThis.location.reload();
  }
});
